/**
 * smsRefusal.js - PROD-807 (patient half): the API refuses to text a number outside the
 * US and Canada, and says so with HTTP 400 {"error": <sentence>, "code": "sms_us_ca_only"}.
 * Nothing was sent. The SSO 2FA challenge stays a 403 and carries
 * smsSent:false, smsRefused:"sms_us_ca_only", smsRefusedMessage:<sentence>.
 *
 * Callers KEY ON THE CODE, never on the sentence, and show the server's own sentence
 * (English until a Spanish one exists). On a refusal there is no "code sent" state and no
 * resend timer, because nothing went out.
 */
export const SMS_REFUSED_CODE = 'sms_us_ca_only'

/** True when the thrown value (or a store result) is the US/Canada-only refusal. */
export function isSmsRefused(e) {
  return !!e && (e.code === SMS_REFUSED_CODE || e.smsRefused === SMS_REFUSED_CODE)
}

/** The server's sentence for a refusal, or null when it sent none. */
export function smsRefusedSentence(e) {
  if (!e) return null
  const s = e.smsRefusedMessage || e.error
  return typeof s === 'string' && s.trim() ? s.trim() : null
}

/**
 * PROD-1166: the number is unsubscribed from Orella texts (Twilio STOP). The API says so ONLY on a
 * FAILED sign-in code send, as `smsOptedOut: true` in the answer (HTTP 200, smsSent:false), or as
 * code 'sms_opted_out'. Strictly `=== true` / the exact code: an old API sends neither, and then
 * the caller behaves exactly as before. Never infer an opt-out from a failure alone.
 */
export const SMS_OPTED_OUT_CODE = 'sms_opted_out'

/** True when an answer or a thrown value carries the opt-out marker. */
export function isSmsOptedOut(x) {
  return !!x && (x.smsOptedOut === true || x.code === SMS_OPTED_OUT_CODE)
}

/**
 * The Settings read key (GET /notification-preferences -> smsOptedOut). True only for a literal
 * true; absent (old API, no phone, lookup failed) is "unknown" and shows nothing.
 */
export function isSmsOptedOutKnown(res) {
  return !!res && res.smsOptedOut === true
}
